import React from "react";
import { useTranslation } from "react-i18next";
import { InputAutoresize } from "../../../common/components/form";

export default function WStep3Product(props) {
    const { t } = useTranslation();

    const {
        set,
        variables: { ProductType, ProductName, ProductDescription, ProductDescriptionShort, BusinessName },
    } = props;

    const isECommerce = ProductType === "ecommerce";

    function onChange({ target: { name, value } }) {
        set({ [name]: value });
    }

    return (
        <div className="wizard-part-inner">
            <div style={{ flex: 1 }}>
                <h1>{t("WizardWStep3Header")}</h1>

                <div className="margin-top-40">
                    <p>{t("WizardWStep3ProductNameText")}</p>

                    <InputAutoresize
                        className="margin-top-20"
                        name="ProductName"
                        onChange={onChange}
                        value={(isECommerce ? BusinessName : ProductName) || ""}
                        placeholder={t("WizardWStep3ProductNameInputPlaceholder")}
                    />
                </div>

                {/* ECommerce "New" */}
                {ProductType === "ecommerce" && (
                    <>
                        <div className="margin-top-40">
                            <p>{t("ECommerceProductDescriptionShortText")}</p>

                            <InputAutoresize
                                className="margin-top-20"
                                name="ProductDescriptionShort"
                                onChange={onChange}
                                value={ProductDescriptionShort || ""}
                                placeholder={t("ECommerceProductDescriptionShortPlaceholder")}
                                rows="2"
                            />
                        </div>

                        <div className="margin-top-40">
                            <p>{t("ECommerceProductDescriptionText")}</p>

                            <InputAutoresize
                                className="margin-top-20"
                                name="ProductDescription"
                                onChange={onChange}
                                value={ProductDescription || ""}
                                placeholder={t("ECommerceProductDescriptionPlaceholder")}
                                rows="2"
                            />
                        </div>
                    </>
                )}

                {/* Other types */}
                {ProductType !== "ecommerce" && (
                    <>
                        <div className="margin-top-40">
                            <p>{t("WizardWStep3ProductDescriptionText")}</p>

                            <InputAutoresize
                                className="margin-top-20"
                                name="ProductDescription"
                                onChange={onChange}
                                value={ProductDescription || ""}
                                placeholder={t("WizardWStep3ProductDescriptionInputPlaceholder")}
                                rows="2"
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
